module.exports = __webpack_public_path__ + "static/media/logo-departament.51f7e274.png";